import { Key, useEffect, useRef, useState } from "react";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownCheckElementType, OptionType } from "../helpers/types";

type Props = {
    value: string[];
    onChange: (value: string[]) => void;
    error: string | null;
}

const DropdownCheck = (props: DropdownCheckElementType & Props) => {
    const { value, onChange, error, label, options, placeholder, description } = props;
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [margin, setMargin] = useState<number | null>(null)
    const nodeRef = useRef<HTMLDivElement>(null);

    const Option = ({ item }: { item: OptionType }) => (
        <li
            className={value.includes(item.value) ? 'bg-primary-subtle active' : ''}
            onClick={() => handleChange(item)}
        >
            <div className="checkbox">
                {value.includes(item.value) ? <FontAwesomeIcon icon={["fas", "check"]} className="text-white" size="xs" /> : ''}
            </div>
            {item.label}
        </li>
    );

    const handleChange = (object: OptionType) => {
        if (value.includes(object.value)) {
            onChange(value.filter(v => v !== object.value));
        } else {
            onChange([...value, object.value]);
        }
    };

    useEffect(() => {
        if (nodeRef?.current) {
            setMargin(nodeRef?.current?.clientHeight)
        } else {
            setMargin(null);
        }
    }, [dropdownOpen]);

    return (
        <div className="form-group position-relative" style={{ marginBottom: margin ?? 0 }}>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className={`form-control ${error && value.length ? 'is-invalid' : value.length ? 'is-valid' : ''}`} onClick={(event) => {
                const target = event.target as HTMLElement;
                if (target.nodeName !== 'path' && target.nodeName !== 'svg') {
                    setDropdownOpen(!dropdownOpen);
                }
            }}>
                <div className={`dropdown input-group ${dropdownOpen ? 'focus' : ''}`}>
                    <div className="d-flex flex-wrap gap-1">
                        {value.length ? value.map((val: string, index: Key) => {
                            const option = options.find(o => o.value === val);
                            return (
                                <div className="ms-choice ps-3 pe-2 rounded-pill" key={index}>
                                    {option?.label ?? val}
                                    <span
                                        className="svg-inside remove-choice"
                                        onClick={() => onChange(value.filter(v => v !== val))}
                                    >
                                        <FontAwesomeIcon
                                            className="remove-choice"
                                            icon={["fas", "xmark"]}
                                            onClick={() => onChange(value.filter(v => v !== val))}
                                        />
                                    </span>
                                </div>
                            );
                        }) : (
                            (placeholder ?? 'Velg et eller flere')
                        )}
                    </div>
                </div>
            </div>

            {dropdownOpen && (
                <div ref={nodeRef} className="dropdown-options multiple w-100" tabIndex={0} onBlur={() => setDropdownOpen(false)}>
                    <ul>
                        {options.map((item: OptionType, index: Key) => (
                            <Option
                                key={index}
                                item={item}
                            />
                        ))}
                    </ul>
                </div>
            )}
            {error && value.length && <div className="invalid-feedback">{parse(error)}</div>}
        </div>
    )
}

export default DropdownCheck;
